import Cookies from 'js-cookie';
import analytics from './analytics.js'
import {
	isEmpty
} from './index.js'

const CookieKey = {
	USERID: '__user_id__',
	LOGIN_ID: '__login_id__',
	TOKEN: '__token__',
	TIMESTAMP: '__timestamp__'
}

export default {
	setLoginDataToCookie: function(data) {
		Cookies.set(CookieKey.USERID, data.userId);
		Cookies.set(CookieKey.LOGIN_ID, data.loginId);
		Cookies.set(CookieKey.TOKEN, data.token);
		Cookies.set(CookieKey.TIMESTAMP, data.timestamp);
		analytics.identify(data.userId);
	},
	clearCookieLoginData: function() {
		analytics.clearPlayer();
		Cookies.remove(CookieKey.USERID);
		Cookies.remove(CookieKey.LOGIN_ID);
		Cookies.remove(CookieKey.TOKEN);
		Cookies.remove(CookieKey.TIMESTAMP);
	},
	getLoginToken: function() {
		return Cookies.get(CookieKey.TOKEN);
	},
	getUserId: function() {
		return Cookies.get(CookieKey.USERID);
	},
	hasLogin: function() {
		return !isEmpty(Cookies.get(CookieKey.USERID)) && !isEmpty(Cookies.get(CookieKey.TOKEN)) && !isEmpty(Cookies.get(
			CookieKey.TIMESTAMP));
	}
}